const getApiUrl = () => {
  // Si on est sur le nom de domaine en ligne
  if (typeof window !== 'undefined' && window.location.hostname.includes('lamp-edification.org')) {
    return "https://api.lamp-edification.org";
  }
  // Sinon (local ou autre), on utilise la variable d'env ou localhost
  return process.env.REACT_APP_API_URL || "http://localhost:5000";
};

const API_URL = getApiUrl();

export default API_URL;
